import { render, staticRenderFns } from "./OfferWrapper.vue?vue&type=template&id=46b110c0&scoped=true"
import script from "./OfferWrapper.vue?vue&type=script&lang=ts"
export * from "./OfferWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b110c0",
  null
  
)

export default component.exports